import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  const quickLinks = [
    { label: t('hero.cta_primary'), href: 'https://kaspreadsheet.com' },
    { label: t('hero.cta_buy'), href: 'https://kaspreadsheet.com' },
    { label: t('nav.article'), href: '/artykul/przewodnik-kakobuy-spreadsheet' },
  ];

  const articleLinks = [
    { label: 'Przewodnik Kakobuy Spreadsheet', href: '/artykul/przewodnik-kakobuy-spreadsheet' },
    { label: 'Bezpieczeństwo Zakupów', href: '/artykul/bezpieczenstwo-kakobuy-spreadsheet' },
    { label: 'Poradnik Zakupowy', href: '/artykul/poradnik-zakupowy-kakobuy' },
    { label: 'Jak Znaleźć Produkty', href: '/artykul/jak-znalezc-najlepsze-produkty-kakobuy' },
  ];

  return (
    <footer className="w-full py-16 md:py-20 bg-background-100 border-t border-background-200/70">
      <div className="px-4 md:px-6 lg:px-10 max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-table-line text-background-50 text-base"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-foreground-900 whitespace-nowrap">
                KakobuyFinds
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-md">
              {t('footer.description')}
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4 whitespace-nowrap">
              {t('footer.quick_links')}
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  {link.href.startsWith('http') ? (
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  ) : (
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4 whitespace-nowrap">
              {t('footer.articles')}
            </h4>
            <ul className="space-y-2.5">
              {articleLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4 whitespace-nowrap">
              {t('footer.categories')}
            </h4>
            <div className="grid grid-cols-2 gap-x-4 gap-y-2">
              {categories.slice(0, 8).map((cat) => (
                <a
                  key={cat.nameKey}
                  href={cat.link}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer whitespace-nowrap truncate"
                >
                  {t(cat.nameKey)}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/70">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500 whitespace-nowrap">
              {t('footer.copyright')}
            </p>
            <div className="flex items-center gap-4">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap">
                kaspreadsheet.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}